import * as React from 'react';
const FormHelperCore = (props) => {
    const { id, type, text, className, components: { Icon, Spinner, }, } = props;
    const BEM = () => {
        const classArray = ['form-helper'];
        if (type) {
            classArray.push('form-helper--' + type);
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const getModifier = () => {
        switch (type) {
            case 'error':
                return '#alert';
            default:
                return '#info-round';
        }
    };
    const getIcon = () => {
        if (type === 'valid') {
            return (React.createElement("svg", { preserveAspectRatio: "xMidYMid", width: "16", height: "16", viewBox: "0 0 16 16", focusable: "false" },
                React.createElement("circle", { className: "form-helper__check-circle", fill: "transparent", stroke: "#00CC66", cx: "8", cy: "8", r: "7" }),
                React.createElement("polyline", { className: "form-helper__check-check", stroke: "#FFFFFF", strokeLinecap: "round", strokeLinejoin: "round", points: "5.3125 8.5625 7.4375 10.5 10.6875 5.285", fill: "transparent" })));
        }
        else if (type === 'loading') {
            return React.createElement(Spinner, { className: "form-helper__spinner" });
        }
        return React.createElement(Icon, { modifiers: getModifier() });
    };
    return (React.createElement("div", { className: BEM(), id: id },
        React.createElement("span", { className: "form-helper__icon" }, getIcon()),
        React.createElement("span", { className: "form-helper__content" }, text)));
};
export { FormHelperCore as default, };
